import type { Song } from "../types";

/** Los pollitos say (traditional Hispanic American, public domain). */
export const losPollitos: Song = {
  id: "los-pollitos",
  title: "Los pollitos dicen",
  bpm: 100,
  instrument: "piano",
  notes: [
    { key: "E4", beats: 1 },
    { key: "E4", beats: 0.5 },
    { key: "E4", beats: 0.5 },
    { key: "D4", beats: 0.5 },
    { key: "E4", beats: 0.5 },
    { key: "F4", beats: 1 },
    { key: "F4", beats: 0.5 },
    { key: "F4", beats: 0.5 },
    { key: "E4", beats: 0.5 },
    { key: "F4", beats: 0.5 },
    { key: "G4", beats: 1 },
    { key: "C5", beats: 1 },
    { key: "B4", beats: 0.5 },
    { key: "A4", beats: 0.5 },
    { key: "G4", beats: 0.5 },
    { key: "F4", beats: 0.5 },
    { key: "E4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "G4", beats: 1 },
    { key: "G4", beats: 0.5 },
    { key: "G4", beats: 0.5 },
    { key: "F4", beats: 0.5 },
    { key: "G4", beats: 0.5 },
    { key: "A4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "F4", beats: 0.5 },
    { key: "F4", beats: 0.5 },
    { key: "E4", beats: 0.5 },
    { key: "F4", beats: 0.5 },
    { key: "G4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "C4", beats: 2 },
  ],
};
